import angular from 'angular';

import '../../order/refund_list/controller';
import '../../order/refund/controller';
import '../../order/void_list/controller';
import '../../../main/factory/order_transaction';
import '../../../main/factory/authentication';
import '../../../core/main/factory/analytics';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.order.total", [
    "merchant.application.module.order.refundList",
    "merchant.application.module.order.refund",
    "merchant.application.module.order.voidList",
]).controller("merchant.application.module.order.total.controller", [
    "$rootScope", "$scope", "$controller", "$window",
    "merchant.application.main.factory.orderTransaction",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.analytics",
    function($rootScope, $scope, $controller, $window, OrderTransaction, Authentication, Analytics) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.orderTotal) {
            $scope.model.orderTotal = {};
        }

        if (! $scope.model.order) {
            $scope.model.order = { source: "" };
        }

        $scope.showRefundList = function() {
            Analytics.sendAmplitudeEvent('Clicked Less returns link')
            $scope.model.modulesIncludedInModal = ["order-refund-list.html"];
            $scope.model.isModalVisible = true;
        };

        $scope.showVoidList = function() {
            $scope.model.modulesIncludedInModal = ["order-void-list.html"];
            $scope.model.isModalVisible = true;
        };

        $scope.showIssueRefund = function() {
            Analytics.sendAmplitudeEvent('Clicked Issue Refund button from Order Total')
            $scope.model.orderRefund = angular.copy($scope.model.orderTotal);
            $scope.model.modulesIncludedInModal = ["order-refund.html"];
            $scope.model.isModalVisible = true;
        };

        $scope.orderRefundAvailable = function() {
            const excludedSources = [
                "POS_CARD",
                "POS_CARD_ONLINE",
                "VIRTUAL_CARD_ONLINE",
                "SINGLE_USE_CARD",
                "POS",
                "ANYWHERE_CARD",
                "ANYWHERE_CARD_ONLINE",
                "CASH_APP_AP_BUTTON",
                "CASH_APP_VIRTUAL_CARD",
                "CASH_APP_SINGLE_USE_CARD",
                "TERMINAL"
            ];
            return (
                $scope.model.orderTotal &&
                !excludedSources.includes($scope.model.order.source) &&
                $scope.model.orderTotal.status === "APPROVED" &&
                $scope.model.orderTotal.openToRefundAmount &&
                parseFloat($scope.model.orderTotal.openToRefundAmount.amount) > 0
            );
        };

        $scope.canVoid = function(order) {
            return order && order.source !== "POS_CARD" && order.source !== "POS_CARD_ONLINE";
        };

        $scope.voidAuth = function(order) {
            if ($scope.canVoid(order) && $window.confirm("Are you sure?")) {
                OrderTransaction.void({
                    merchantId: Authentication.merchantId(),
                    transactionId: order && order.id
                }, function(updatedOrderData) {
                    $rootScope.$broadcast("authVoided", updatedOrderData);
                }, angular.noop); // No errors to display
            }
        };

    }
]);
